import { api } from "@/lib/api";

/**
 * Fire-and-forget analytics beacon.
 *
 * Auto-attaches a persistent `_anon_id` (UUID stored in localStorage) so the
 * backend can count unique anonymous visitors even before login.
 *
 *   track("cta_click", { label: "landing_join" })
 *   track("page_view", { path: "/agencies" })
 */
const ANON_ID_KEY = "nh_anon_id";

function getAnonId() {
  try {
    let id = localStorage.getItem(ANON_ID_KEY);
    if (!id) {
      // Prefer crypto.randomUUID when available (modern browsers), fallback to Math.random.
      id = (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `a-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(ANON_ID_KEY, id);
    }
    return id;
  } catch {
    return null; // localStorage disabled / SSR — degrade to null and skip anon tracking
  }
}

export async function track(event, meta = {}) {
  try {
    const anonId = getAnonId();
    const payload = { event, meta: { ...meta, ...(anonId ? { _anon_id: anonId } : {}) } };
    await api.post("/analytics/event", payload);
  } catch {
    /* analytics must never block UX */
  }
}
